import React from 'react'

const FeesPresetsDefault  = () => (
  <div className="jumbotron">
    <h1>Fees Presets</h1>
    <hr/>
    <p>Here you can define your own fees presets. Pre-defined fees to conveniently load fees in the payment module.</p>
  </div>
)

export default FeesPresetsDefault



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/default.js